/* eslint-disable consistent-return */
import { Button, Grid } from '@material-ui/core';
import { postStudentCompetencePerso } from '@webapps/business';
import {
  FormikAutocomplete,
  FormikAutocomplete50,
  FormikAutocompletePx,
  useAuth,
  useMutation,
  useToast,
} from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import Row from 'components/Form/Row';
import { useFormik } from 'formik';
import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import * as yup from 'yup';

const competenceSchema = yup.object().shape({
  label: yup.string().required('Requis'),
});

const QUALITES = [
  { label: 'Capacité d’adaptation', id: 1 },
  { label: 'Gestion du stress', id: 2 },
  { label: 'Travail en équipe', id: 3 },
  { label: 'Capacité à fédérer', id: 4 },
  { label: 'Sens de la communication', id: 5 },
  { label: 'Autonomie', id: 6 },
  { label: 'Capacité de décision', id: 7 },
  { label: 'Réactivité', id: 8 },
  { label: 'Prise de recul', id: 9 },
  { label: 'Persévérance', id: 10 },
  { label: 'Curiosité', id: 11 },
  { label: 'Force de proposition', id: 12 },
  { label: 'Rigueur', id: 13 },
  { label: 'Sens de l’organisation', id: 14 },
  { label: 'Créativité', id: 15 },
  { label: 'Empathie', id: 16 },
  { label: 'Leadership', id: 17 },
  { label: 'Diplomatie', id: 18 },
  { label: 'Flexible', id: 19 },
  { label: 'Ouverture d\'esprit', id: 20 },
  { label: 'Bonne gestion du temps', id: 21 },
  { label: 'Esprit d\'initiative', id: 22 },
  { label: 'Patience', id: 23 },
  { label: 'Capacité d\'écoute active', id: 24 },
  { label: 'Sens de l\'éthique', id: 25 },
  { label: 'Habiletés de négociation', id: 26 },
  { label: 'Gestion des conflits', id: 27 },
  { label: 'Prise de responsabilités', id: 28 },
  { label: 'Sens de l’humour', id: 29 },
  { label: 'Capacité à inspirer les autres', id: 30 },
  { label: 'Capacité à apprendre rapidement', id: 31 },
  { label: 'Pensée critique', id: 32 },
  { label: 'Fiabilité', id: 33 },
  { label: 'Perspicacité', id: 34 },
  { label: 'Ténacité', id: 35 },
  { label: 'Sens de l\'empathie', id: 36 },
  { label: 'Esprit d\'équipe', id: 37 },
  { label: 'Honnêteté', id: 38 },
  { label: 'Intelligence émotionnelle', id: 39 },
  { label: 'Gestion de projet', id: 40 },
  { label: 'Sens de la perspective', id: 41 },
  { label: 'Sens de l\'écoute', id: 42 },
  { label: 'Polyvalence', id: 43 },
  { label: 'Adaptabilité à la technologie', id: 44 },
  { label: 'Convivialité', id: 45 },
  { label: 'Capacité à encourager les autres', id: 46 },
  { label: 'Capacité à inspirer la confiance', id: 46 },
  { label: 'Gestion des priorités', id: 47 },
];

const AddCompetence = ({ close, refetch }) => {
  const { css } = useStyles();

  const { idUser } = useAuth();

  const {
    isLoading,
    isSuccess,
    mutateAsync: mutateCompetencePerso,
  } = useMutation(postStudentCompetencePerso);

  const { addToast } = useToast();

  useEffect(() => {
    if (isSuccess) {
      addToast({
        status: 'success',
        message: 'Opération réussie',
      });
      refetch();
      close();
    }
  }, [isSuccess]);

  const formik = useFormik({
    initialValues: {
      label: '',
    },
    validationSchema: competenceSchema,
    onSubmit: async (values) => {
      try {

        const response = await mutateCompetencePerso({
          data: values,
          id: idUser,
        });

        if (response?.error) {
          addToast({
            status: 'error',
            message: response.error,
          });
        }
      } catch (error) {
        // Si il y a une erreur 400, ça veut dire que la compétence existe déjà
        if (error.includes("400")) {
          addToast({
            status: 'error',
            message: 'La compétence existe déjà',
          });
        }
      }
    },
  });

  return (
    <div>
      <Row>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <FormikAutocompletePx
              defaultValue=""
              formik={formik}
              fullWidth
              borderRadius={6}
              getOptionLabel={(option) => option.label || ''}
              getOptionSelected={(option, value) =>
                value.label === option.label
              }
              label="Intitulé de la qualité"
              name="label"
              options={QUALITES}
              pathValue="label"
              value={
                QUALITES.find(({ label }) => label === formik.values.label) ||
                null
              }
            />
          </Grid>
        </Grid>
      </Row>
      <Row>
        <Grid container spacing={2}>
          <Grid className={css({ textAlign: 'center' })} item xs>
            <Button
              className={css({ borderRadius: '400px' })}
              color="primary"
              disabled={isLoading}
              onClick={formik.handleSubmit}
              variant="contained"
            >
              <FormattedMessage id="vitrine.btnCreate" />
            </Button>
          </Grid>
        </Grid>
      </Row>
    </div>
  );
};

AddCompetence.propTypes = {
  refetch: PropTypes.func,
  close: PropTypes.func,
};

export default AddCompetence;
